module.exports = __webpack_public_path__ + "img/组 3.90bd07bd.webp";